export default function CadastroFornecedor(){
    return(
        "Cadastro Fornecedor"
    );
}